import * as React from 'react';
import { ClaimService } from 'services/ApiService';
import { ClaimType, ToastState } from 'types';
import Toast from '../Toast';

type ReturnInvoiceFormProps = {
  claimType: ClaimType;
  id: number;
  default: string | null;
  disabled?: boolean;
};

type ReturnInvoiceFormState = {
  default: string | null | undefined;
  input: string | null | undefined;
};

/**
 * Form for submitting return invoice.
 */
class ReturnInvoiceForm extends React.Component<
  ReturnInvoiceFormProps,
  ReturnInvoiceFormState
> {
  constructor(props: ReturnInvoiceFormProps) {
    super(props);
    this.state = {
      default: props.default,
      input: props.default,
    };

    this.handleChange = this.handleChange.bind(this);
    this.submit = this.submit.bind(this);
  }

  handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ input: (event.target as HTMLTextAreaElement).value });
  }

  async submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    let res;
    if (this.state.input === undefined) {
      res = await ClaimService.patch({
        type: this.props.claimType,
        id: this.props.id,
        returnInvoice: '',
      });
    } else {
      res = await ClaimService.patch({
        type: this.props.claimType,
        id: this.props.id,
        returnInvoice: this.state.input,
      });
    }
    if (res && res.returnInvoice) {
        Toast.present(
          { message: 'Return Invoice Updated' },
          ToastState.SUCCESS
        );
    }
    this.setState({ default: this.state.input });
  }

  render() {
    return (
      <form onSubmit={this.submit}>
        <label>
          <textarea
            disabled={this.props.disabled}
            rows={2}
            style={{ width: '40%' }}
            defaultValue={
              this.state.default === null ? '' : this.state.default
            }
            value={this.state.input || ''}
            onChange={(e) => this.handleChange(e)}
          />
          <button disabled={this.props.disabled || this.state.default === this.state.input} type="submit" value="submit">
            Save
          </button>
        </label>
      </form>
    );
  }
}
export default ReturnInvoiceForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ReturnInvoiceForm/index.tsx